import { Text } from '@thanx/uikit/text'
import { useStyletron } from '@thanx/uikit/theme'
import Badge from 'components/Badge'
import palette from 'constants/palette'
import { buildTranslate } from 'locales'
import React from 'react'

const t = buildTranslate('live_updates.order_ratings_disabled')

const CARD_RADIUS = '12px'
const GAP = '12px'
const BOX_MIN_HEIGHT = '340px'
const BODY_MAX_WIDTH = '460px'

// Decorative disabled glyph, inline so no new asset ships.
const DisabledIcon = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 24 24"
    fill="none"
    stroke={palette.grey50}
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
    data-testid="order-ratings-disabled-icon"
  >
    <path d="M12 2.5l2.9 5.9 6.5.95-4.7 4.6 1.1 6.5L12 17.4l-5.8 3.05 1.1-6.5-4.7-4.6 6.5-.95z" />
    <path d="M10.2 10.5v4M13.8 10.5v4" />
  </svg>
)

// Stands in for the Looker report while live updates are off, so it makes no
// data request. It has no button: the banner above carries the resume link.
const OrderRatingsDisabledCard = () => {
  const [css] = useStyletron()

  return (
    <section
      data-testid="order-ratings-disabled-card"
      className={css({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        gap: GAP,
        minHeight: BOX_MIN_HEIGHT,
        paddingTop: '32px',
        paddingBottom: '32px',
        paddingLeft: '24px',
        paddingRight: '24px',
        borderRadius: CARD_RADIUS,
        borderTopWidth: '1px',
        borderRightWidth: '1px',
        borderBottomWidth: '1px',
        borderLeftWidth: '1px',
        borderTopStyle: 'dashed',
        borderRightStyle: 'dashed',
        borderBottomStyle: 'dashed',
        borderLeftStyle: 'dashed',
        borderTopColor: palette.grey30,
        borderRightColor: palette.grey30,
        borderBottomColor: palette.grey30,
        borderLeftColor: palette.grey30,
        backgroundColor: palette.white,
      })}
    >
      <DisabledIcon />
      <div className={css({ display: 'flex', alignItems: 'center', gap: GAP })}>
        <Text.Header4 tag="h2" className={css({ margin: 0 })}>
          {t('heading')}
        </Text.Header4>
        <Badge className="grey-70 grey-20-bkg" value={t('badge')} />
      </div>
      <Text.Header4 tag="h3" className={css({ margin: 0 })}>
        {t('title')}
      </Text.Header4>
      <Text.BodyText4
        color="grey90"
        className={css({ display: 'block', maxWidth: BODY_MAX_WIDTH })}
      >
        {t('saved_note')}
      </Text.BodyText4>
      <Text.BodyText4
        color="grey70"
        className={css({ display: 'block', maxWidth: BODY_MAX_WIDTH })}
      >
        {t('body')}
      </Text.BodyText4>
    </section>
  )
}

export default OrderRatingsDisabledCard
